import Tooltip from '@material-ui/core/Tooltip';

function TooltipWrapper({tooltip, children, label}){

  if( tooltip ){
    return (
      <Tooltip title={tooltip}>
        <div>
          {children}
        </div>
      </Tooltip>
    )
  }else{
    return children;
  }

}


export default function Navbar({
  name,
  options,selected,onSelect,fontSize,spread,
  hoverClass,
  selectedClass,
  style,
  outerStyle,
  direction="row",

}){

  return (
    <div style={outerStyle} class={`sg-${direction}`}>
      {options.map( (opt,ii) => {

        let finalHoverClass = opt.hoverClass || hoverClass || "hoverable";
        let finalSelectedClass = (opt._id===selected?(opt.selectedClass || selectedClass || "selected"):"");

        return (
          <TooltipWrapper tooltip={opt.tooltip} label={opt.label}>
          <div 

            tab={opt.tab || opt._id}
            item={opt._id}
            navbar={name}
            style={{
              whiteSpace:'nowrap',
              fontSize:(fontSize||13),
              ...(style || {}),
              ...(opt.style || {}),
            }}
            onClick={() => {
              if(!onSelect){
                ;
              }

              onSelect && onSelect(opt._id)
            }}
            class={
              finalHoverClass+" selectable round-corners small-padding "+finalSelectedClass
            }>{opt.label}</div>

          {spread !== false && ii!==options.length-1 && 
              <div class="flex-expand"/>
          }
          </TooltipWrapper>
        )
      })}
    </div>
  ) 
}
